import { Injectable } from '@angular/core'
import { Action, select, Store } from '@ngrx/store'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'
import { RootState } from './invoice.reducer'
import * as InvoiceSelectors from './invoice.selectors'

@Injectable({ providedIn: 'root' })
export class InvoiceFacade implements GbBaseFacade {
  invoice$ = this.store.pipe(select(InvoiceSelectors.getInvoice))
  hasUnpaidInvoice$ = this.store.pipe(select(InvoiceSelectors.getHasUnpaidInvoice))
  lineItems$ = this.store.pipe(select(InvoiceSelectors.getInvoiceLineItems))
  loaded$ = this.store.pipe(select(InvoiceSelectors.getInvoiceLoaded))
  isEmptyInvoice$ = this.store.pipe(select(InvoiceSelectors.isEmptyInvoice))

  constructor(private store: Store<RootState>) {}

  dispatch(action: Action) {
    this.store.dispatch(action)
  }
}
